import axios from 'axios';

const isDev = __MODE__ == 'development';
const isDevStand = location.host.startsWith('dev.'); // TODO

const apiUrl = isDev
  ? 'http://localhost:1338/api'
  : `https://${isDevStand ? 'dev.' : ''}strapi.tls-group.online/api`;
export const serverUrl = isDev
  ? 'http://localhost:1338'
  : `https://${isDevStand ? 'dev.' : ''}strapi.tls-group.online`;

export const getToken = () => {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

export const getUser = async () => {
  try {
    const response = await apiClient.get('/users/me');
    const data = response.data;

    const isAdmin = await checkIfAdmin();

    const result = {
      ...data,
      isAdmin,
    };

    if (data.inn) {
      try {
        const agentResponse = await apiClient.get('/agents/me');
        return {
          ...result,
          ...agentResponse.data,
        };
      } catch (e) {
        return result;
      }
    }
    return result;
  } catch (err) {
    console.error('Ошибка получения пользователя:', err);
    return null;
  }
};
export const checkIfAdmin = async () => {
  try {
    const response = await apiClient.post('/custom-check-role');
    const role = response.data;
    return role?.data?.role === 'Administrator';
  } catch (error) {
    console.error('Error fetching user data:', error);
    return false;
  }
};
export const getAgent = async () => {
  try {
    const response = await apiClient.get('/agent/is-agent');
    return response.data;
  } catch (err) {
    // console.error('Ошибка получения пользователя:', err);
    return null;
  }
};

export const checkAuth = async () => {
  const token = getToken();
  if (token) {
    try {
      const response = await apiClient.post('/custom-check-role');
      const role = response.data;
      if (role && role.data.role === 'Administrator') {
        window.location.href = '/dashboard/admin/last';
      }
      if (role && role.data.role === 'Authenticated') {
        window.location.href = '/dashboard/last';
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  }
};

export const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 30000,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Токен недействителен, выход из системы.');
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  },
);
